module.exports = __webpack_public_path__ + "img/1662.fd005e83.jpg";